import { Button, Text } from '@mantine/core';
import { Link } from '@inertiajs/react';
import { Post } from './types';
interface PostDrawerContentProps {
  post: Post;
}
export default function PostDrawerContent({ post }: PostDrawerContentProps) {
  return (
    <>
      <Text weight={500} size="lg" mb="md">
        {post.title}
      </Text>
      <Link href={`/posts/${post.slug}`} prefetch={false}>
        <p>Go to Post</p>
      </Link>
    </>
  );
}
